import { serviceName } from '../resources/serviceConstants';
import {
  STAFFING_STATUS_MASTER,
  STAFFING_LOST_DROPPED_STATUS,
  STAFFING_GEOGRAPHY,
} from '../resources/endPoint';

export const getStaffingStatus = (statusName, statusCategory, activeOnly = false) => {
  // API call to fetch staffing status
  let url = STAFFING_STATUS_MASTER;
  const queryParams = [];
  if (statusName) {
    queryParams.push(`name=${encodeURIComponent(statusName)}`);
  }
  if (statusCategory) {
    queryParams.push(`category=${encodeURIComponent(statusCategory)}`);
  }
  if (activeOnly) {
    queryParams.push(`isActiveFlag=${activeOnly}`);
  }
  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }
  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const addStaffingStatus = (data) => {
  // API call to add staffing status data

  return {
    url: STAFFING_STATUS_MASTER,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};


export const editStaffingStatus = (data) => {
  // API call to edit staffing status data

  return {
    url: STAFFING_STATUS_MASTER,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const deleteStaffAugStatus = (statusId, statusCategory) => {
  // API call to delete staffing status data
  const url = `${STAFFING_STATUS_MASTER}/${statusId}/${statusCategory}`;
  return {
    url: url,
    method: 'delete',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const getLostDroppedStatus = () => {
  return {
    url: STAFFING_LOST_DROPPED_STATUS,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};
export const addLostDroppedStatus = (data) => {
  return {
    url: STAFFING_LOST_DROPPED_STATUS,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const editLostDroppedStatus = (data) => {


  return {
    url: STAFFING_LOST_DROPPED_STATUS,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const deleteLostDroppedStatus = (statusId) => {
  return {
    url: `${STAFFING_LOST_DROPPED_STATUS}/${statusId}`,
    method: 'delete',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const addGeography = (data) => {
  return {
    url: STAFFING_GEOGRAPHY,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const updateGeography = (data) => {
  return {
    url: STAFFING_GEOGRAPHY,
    method: 'put',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.MASTER_MS,
  };
};

export const getGeography = () => {
  return {
    url: STAFFING_GEOGRAPHY,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.MASTER_MS,
  };
};

export const deleteStaffGeographyMaster = (payload) => {
  // API call to delete staff geography master data
  return {
    url: STAFFING_GEOGRAPHY,
    method: 'delete',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    payload: payload,
    service: serviceName.MASTER_MS,
  };
};

